
<div class="pie">
  <div class="pie__element pie__element--left" *ngIf="percent &gt; 50">
    <div class="pie__chart" [style.transform]="'rotate('+rotate.left+'deg)'"></div>
  </div>
  <div class="pie__element pie__element--right">
    <div class="pie__chart" [style.transform]="'rotate('+rotate.right+'deg)'"></div>
  </div>
</div>